import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { MasterOperatorModule } from '@cloud-twin/master-operator/master-operator.module';
import { DynamicLayoutModule } from '@common-modules/dynamic-layout/dynamic-layout.module';
import { GenericStoreService } from '@common-modules/dynamic-layout/state/generic/generic-store.service';
import { ReduxStateModule } from '@common-modules/redux/redux-state.module';
import { CommonSharedComponentModule } from '@common-modules/shared-component/common-shared-component.module';
import { CommonSharedModule } from '@common-modules/shared/common-shared.module';
import { MaterialSharedModule } from '@common-modules/shared/material-shared.module';
import { WidgetRegistryService } from '@common-modules/widget-registry/widget-registry';
import { WLMGridModule } from '@common-modules/wlm-grid/wlm-grid.module';
import { TranslateModule } from '@ngx-translate/core';
import { ModelVersionGridWidgetComponent } from './model-version-grid-widget/model-version-grid-widget.component';
import { ModelVersionGridComponent } from './model-version-grid/model-version-grid.component';
import { ModelVersionPageComponent } from './model-version-page/model-version-page.component';
import { ModelVersionRoutingModule } from './model-version-routing.module';
import { ModelVersionScenariosGridWidgetComponent } from './model-version-scenarios-grid-widget/model-version-scenarios-grid-widget.component';
import { ModelVersionScenariosGridComponent } from './model-version-scenarios-grid/model-version-scenarios-grid.component';
import { ModelVersionSelectionWidgetComponent } from './model-version-selection-widget/model-version-selection-widget.component';
import { ModelsSelectionComponent } from './models-selection/models-selection.component';
import { ModelVersionService } from './services/model-version.service';

@NgModule({
  declarations: [
    ModelVersionPageComponent,
    ModelVersionSelectionWidgetComponent,
    ModelsSelectionComponent,
    ModelVersionGridWidgetComponent,
    ModelVersionGridComponent,
    ModelVersionScenariosGridComponent,
    ModelVersionScenariosGridWidgetComponent,
  ],
  imports: [
    ReduxStateModule,
    CommonModule,
    CommonSharedModule,
    CommonSharedComponentModule,
    MaterialSharedModule,
    TranslateModule,
    DynamicLayoutModule,
    MasterOperatorModule,
    ReduxStateModule.forFeature({
      storeServices: [GenericStoreService],
    }),
    WLMGridModule,
    ModelVersionRoutingModule,
  ],
  providers: [
    ModelVersionService,
    { provide: 'ModelVersionService', useExisting: ModelVersionService },
  ],
  exports: [
    ModelVersionSelectionWidgetComponent,
    ModelVersionPageComponent,
    ModelsSelectionComponent,
    ModelVersionGridWidgetComponent,
    ModelVersionGridComponent,
  ],
})
export class ModelVersionModule {
  static injector: Injector;
  constructor(injector: Injector, private _widgetRegistry: WidgetRegistryService) {
    ModelVersionModule.injector = injector;
    this._widgetRegistry.register([
      {
        name: 'ModelVersionSelectionWidgetComponent',
        widgetClass: ModelVersionSelectionWidgetComponent,
      },
      {
        name: 'ModelVersionGridWidgetComponent',
        widgetClass: ModelVersionGridWidgetComponent,
      },
      {
        name: 'ModelVersionScenariosGridWidgetComponent',
        widgetClass: ModelVersionScenariosGridWidgetComponent,
      },
    ]);
  }
}
